export default class Campaign {
    id: number;
    campaignCode: string;
    name: string;
    startTime: string;
    endTime: string;
    dataState: number=1;
    organizationUnitId:number=0;
}